export function onDocumentLoaded (callback) {
    document.addEventListener("DOMContentLoaded", callback);
}